// Make sure Moment.js is included in your project
import moment from 'moment';
const getUnixTimestamp = dateString => {
  // Create a Moment.js date object from the provided date string
  const date = moment(dateString);

  // Return the Unix timestamp in milliseconds
  return date.valueOf();
};
export default getUnixTimestamp;
